import { light } from '@mui/material/styles/createPalette';

const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#5D87FF',
      light: '#ECF2FF',
      dark: '#4570EA'
    },
    secondary: {
      main: '#49BEFF',
      light: '#E8F7FF',
      dark: '#23afdb'
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff'
    },
    info: {
      main: '#7d7da1',
      light: '#EBF3FE',
      dark: '#7d7da1',
      contrastText: '#ffffff'
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#f3704d',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff'
    },
    green: {
      50: '#F1F8E9',
      100: '#DCEDC8',
      200: '#C5E1A5',
      300: '#AED581',
      400: '#9CCC65',
      500: '#8BC34A',
      600: '#7CB342',
      700: '#689F38',
      800: '#558B2F',
      900: '#33691E',
      A100: '#CCFF90',
      A200: '#B2FF59',
      A400: '#76FF03',
      A700: '#64DD17'
    },
    red: {
      50: '#FFEBEE',
      100: '#FFCDD2',
      200: '#EF9A9A',
      300: '#E57373',
      400: '#EF5350',
      500: '#F44336',
      600: '#E53935',
      700: '#D32F2F',
      800: '#C62828',
      900: '#B71C1C',
      A100: '#FF8A80',
      A200: '#FF5252',
      A400: '#FF1744',
      A700: '#D50000'
    },
    orange: {
      50: '#FFF3E0',
      100: '#FFE0B2',
      200: '#FFCC80',
      300: '#FFB74D',
      400: '#FFA726',
      500: '#FF9800',
      600: '#FB8C00',
      700: '#F57C00',
      800: '#EF6C00',
      900: '#E65100',
      A100: '#FFD180',
      A200: '#FFAB40',
      A400: '#FF9100',
      A700: '#FF6D00'
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9'
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#DFE5EF',
      350: '#ADBACD',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547'
    },
    text: {
      primary: '#2A3547',
      secondary: '#666666',
      third: '#888888'
    },
    action: {
      link: 'rgb(93, 135, 255)',
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc'
    },
    divider: '#c4c9cf',
    scrollbarColor: '#49BEFF80',
    background: {
      light: '#ffffff',
      default: '#ffffff',
      popover: '#171c23'
    }
  }
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#5D87FF',
      light: '#ECF2FF',
      dark: '#4570EA'
    },
    secondary: {
      main: '#777e89',
      light: '#1C455D',
      dark: '#173f98'
    },
    success: {
      main: '#13DEB9',
      light: '#1B3C48',
      dark: '#02b3a9',
      contrastText: '#ffffff'
    },
    info: {
      main: '#539BFF',
      light: '#223662',
      dark: '#1682d4',
      contrastText: '#ffffff'
    },
    error: {
      main: '#FA896B',
      light: '#4B313D',
      dark: '#f3704d',
      contrastText: '#ffffff'
    },
    warning: {
      main: '#FFAE1F',
      light: '#4D3A2A',
      dark: '#ae8e59',
      contrastText: '#ffffff'
    },
    green: {
      50: '#0D1F12',
      100: '#1B3719',
      200: '#2A4F20',
      300: '#396727',
      400: '#48802E',
      500: '#579835',
      600: '#66B03C',
      700: '#75C843',
      800: '#84E04A',
      900: '#93F851',
      A100: '#8BC34A',
      A200: '#7CB342',
      A400: '#689F38',
      A700: '#558B2F'
    },
    red: {
      50: '#1A0B0B',
      100: '#331515',
      200: '#4D1F1F',
      300: '#662929',
      400: '#803333',
      500: '#993D3D',
      600: '#B34747',
      700: '#CC5151',
      800: '#E65B5B',
      900: '#FF6565',
      A100: '#F44336',
      A200: '#E53935',
      A400: '#D32F2F',
      A700: '#C62828'
    },
    orange: {
      50: '#1A1000',
      100: '#332000',
      200: '#4D3000',
      300: '#664000',
      400: '#805000',
      500: '#996000',
      600: '#B37000',
      700: '#CC8000',
      800: '#E69000',
      900: '#FFA000',
      A100: '#FF9800',
      A200: '#FB8C00',
      A400: '#F57C00',
      A700: '#EF6C00'
    },
    purple: {
      A50: '#333F55',
      A100: '#6610f2',
      A200: '#557fb9'
    },
    grey: {
      50: '#3E4A62',
      100: '#333F55',
      200: '#465670',
      300: '#7C8FAC',
      400: '#DFE5EF',
      500: '#EAEFF4',
      600: '#F2F6FA',
      A700: '#465670'
    },
    text: {
      primary: '#EAEFF4',
      secondary: '#7C8FAC',
      third: '#999999'
    },
    action: {
      link: 'rgb(93, 135, 255)',
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#333F55'
    },
    divider: '#333F55',
    scrollbarColor: '#49BEFF80',
    background: {
      light: '#ffffff',
      default: '#171c23',
      dark: '#171c23',
      paper: '#171c23',
      popover: '#ffffff'
    }
  }
};

export { baseDarkTheme, baselightTheme };
